module.exports = __webpack_public_path__ + "static/media/zion-switchbacks.b8a93dea.jpg";